import { TextButton } from '@zillow/constellation-10';
import useOpenRenterDetails from '../../../../hooks/useOpenRenterDetails';
import { FULLSTORY_EXCLUDE_CLASS_NAME } from '@zg-rentals/satellite-components';

type LeadNameButtonProps = {
  conversationId: string;
  // The shared phone-lead label, not a name — skips the capitalize transform.
  isPhoneLeadLabel?: boolean;
  leadName: string;
};

export default function LeadNameButton({ conversationId, isPhoneLeadLabel, leadName }: LeadNameButtonProps) {
  const { canOpenRenterDetails, openRenterDetails } = useOpenRenterDetails();

  return (
    <TextButton
      className={FULLSTORY_EXCLUDE_CLASS_NAME}
      css={{ textTransform: isPhoneLeadLabel ? 'none' : 'capitalize' }}
      disabled={!canOpenRenterDetails}
      id="lead-name"
      onClick={() => openRenterDetails(conversationId)}
      textStyle="body"
      tone="neutral"
    >
      {leadName}
    </TextButton>
  );
}
